import React, { useState } from 'react';
import styles from './styles.module.css';
import * as Icon from '../Icons';
const CountableSet = ({ rooms, setRooms }) => {
  const [change, setChange] = useState(false);
  const ages = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  const AgeSelector = ({ index, childIndex, age }) => {
    return (
      <div className={styles.age}>
        <label htmlFor="age">Age:</label>
        <select
          id="age"
          name="age"
          onChange={(e) => {
            handleAge(index, childIndex, e.target.value);
          }}
          defaultValue={age}
        >
          {ages.map((ageVal) => {
            return (
              <option key={ageVal} value={ageVal} selected={ageVal === age}>
                {ageVal}
              </option>
            );
          })}
        </select>
      </div>
    );
  };

  const handleAge = (index, childIndex, value) => {
    let data = rooms[index].paxInfo;
    let child = data[childIndex];
    child = { ...child, age: value };
    rooms[index].paxInfo[childIndex] = child;
    setRooms(rooms);
    setChange(!change);
  };

  const handleChild = (mode, index) => {
    if (mode === 'plus') {
      if (rooms[index].paxInfo.length < 5) {
        let data = rooms[index].paxInfo;
        data.push({ type: 'CHD', age: 5 });
        rooms[index].paxInfo = data;
        setRooms(rooms);
        setChange(!change);
      }
    } else if (mode === 'minus') {
      if (rooms[index].paxInfo.length > 1) {
        let data = rooms[index].paxInfo;
        data.pop();
        rooms[index].paxInfo = data;
        setRooms(rooms);
        setChange(!change);
      }
    }
  };

  const handleChange = (name, operation, index) => {
    if (operation === 'minus') {
      switch (name) {
        case 'adult':
          rooms[index].paxInfo[0].quantity--;
          setRooms(rooms);
          setChange(!change);
          break;
        case 'children':
          rooms[index].paxInfo[1].quantity--;
          setRooms(rooms);
          setChange(!change);
          break;
        default:
          break;
      }
    } else if (operation === 'plus') {
      switch (name) {
        case 'adult':
          rooms[index].paxInfo[0].quantity++;
          setRooms(rooms);
          setChange(!change);
          break;
        case 'children':
          rooms[index].paxInfo[1].quantity--;
          setRooms(rooms);
          setChange(!change);
          break;
        default:
          break;
      }
    }
  };

  return (
    <div className={styles.container}>
      {rooms.map((room, index) => {
        return (
          <div key={index}>
            <div className={styles.set}>
              <div className={styles.flexContainer}>
                <label className={styles.title} style={{ borderBottom: '1px solid black' }}>
                  Room {index + 1} :
                </label>
                <Icon.Delete
                  onClick={() => {
                    rooms.length > 1 && setRooms(rooms.filter((item, id) => id !== index));
                  }}
                  style={{ width: '1.5rem', height: '1.5rem', marginLeft: '1rem' }}
                  fill={'red'}
                />
              </div>
            </div>
            {/* ADULTS */}
            <div className={styles.set}>
              <div>
                <label className={styles.title}>{'Adult'}</label>
              </div>
              <div className={styles.buttons}>
                <button onClick={() => handleChange('adult', 'minus', index)} disabled={room.paxInfo[0].quantity === 1}>
                  <Icon.Minus />
                </button>
                <span className={styles.countText}>{room.paxInfo[0].quantity}</span>
                <button onClick={() => handleChange('adult', 'plus', index)} disabled={room.paxInfo[0].quantity === 5}>
                  <Icon.Plus />
                </button>
              </div>
            </div>
            {/* CHILDREN */}
            <div className={styles.set}>
              <div>
                <label className={styles.title}>{'Children'}</label>
              </div>
              <div className={styles.buttons}>
                <button onClick={() => handleChild('minus', index)} disabled={room.paxInfo.length < 2}>
                  <Icon.Minus />
                </button>
                <span className={styles.countText}>{room.paxInfo.length - 1}</span>
                <button onClick={() => handleChild('plus', index)}>
                  <Icon.Plus />
                </button>
              </div>
            </div>
            <div className={styles.flexContainer}>
              {room.paxInfo.length > 1 &&
                room.paxInfo.map((visitors, childIndex) => {
                  if (visitors.type === 'CHD') {
                    return (
                      <div>
                        <AgeSelector key={childIndex} index={index} childIndex={childIndex} age={visitors.age} />
                        {/*<p>{visitors.age}</p> just to see the change of value*/}
                      </div>
                    );
                  }
                  return null;
                })}
            </div>
          </div>
        );
      })}

      <button
        className={styles.addNew}
        onClick={() =>
          setRooms([
            ...rooms,
            {
              sequence: rooms.length,
              paxInfo: [{ type: 'ADT', quantity: 2 }],
            },
          ])
        }
      >
        add new room
      </button>
    </div>
  );
};

export default CountableSet;
